import * as React from 'react';

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
const SvgIconCheckboxChecked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm11.118 5.425a.75.75 0 1 0-1.236-.85l-4.99 7.257L5.53 9.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.148-.105l5.5-8z"
      fill="currentColor"
    />
  </svg>
);

export default SvgIconCheckboxChecked;
